import { render, staticRenderFns } from "./wx-open-launch-app-local-v3.vue?vue&type=template&id=6a2bc3bc&scoped=true&"
import script from "./wx-open-launch-app-local-v3.vue?vue&type=script&lang=js&"
export * from "./wx-open-launch-app-local-v3.vue?vue&type=script&lang=js&"
import style0 from "./wx-open-launch-app-local-v3.vue?vue&type=style&index=0&id=6a2bc3bc&lang=stylus&scoped=true&"
import style1 from "./wx-open-launch-app-local-v3.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bc3bc",
  null
  
)

export default component.exports